module.exports = __webpack_public_path__ + "img/frame (115).1e51a259.jpg";